// Citaition Check 5008
const CitationCheckService = '/citation-checking';

// Controllers
const DocumentContentController = `${CitationCheckService}/document-contents`;
const TraineeAnswerCitationController = `${CitationCheckService}/trainee-answer-citations`;

export const CitationCheckManagement = {
    DocumentContent: {
        DocumentContents: DocumentContentController,
        DocumentContentById: (documentId) => `${DocumentContentController}/${documentId}`,
    },
    TraineeAnswerCitation: {
        TraineeAnswerCitations: TraineeAnswerCitationController,
    },
};
